import { ReactNode } from 'react';
import { Text } from '@backstage/ui';
import { ContentCard } from '../ContentCard/ContentCard';
import styles from './SectionCard.module.css';

interface SectionCardProps {
  title: string;
  action?: ReactNode;
  children: ReactNode;
}

export const SectionCard = ({ title, action, children }: SectionCardProps) => (
  <ContentCard>
    <div className={styles.header}>
      <Text as="h6" variant="title-small" className={styles.title}>
        {title}
      </Text>
      {action}
    </div>
    <div className={styles.divider} />
    {children}
  </ContentCard>
);
